import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PracticeStatusService } from "../practice-status.service";

/**
 * RequireMigratedGuard — blocks activation of practice-management routes when
 * the current practice is in the read-only (migration-pending) state
 * (ClioAdmin #85, RC2 QA-enablement auth slice).
 *
 * Applied alongside (not instead of) AuthGuard on the management routes only:
 * `/location`, `/careteams`, `/setting`, `/administration`. Reports / Classic
 * routes are intentionally NOT gated — a read-only practice keeps full
 * VIEW/reporting access.
 *
 * Fail open via `PracticeStatusService.isReadOnly()`: when the practiceStatus
 * claim is absent/unknown the practice is treated as NOT read-only and
 * activation proceeds. When read-only, soft-redirect to /home (the reports
 * home) — matching the AuthGuard's soft-redirect convention for a missing
 * feature entitlement rather than clearing the session.
 */
@Injectable()
export class RequireMigratedGuard implements CanActivate {
    constructor(private router: Router, private practiceStatus: PracticeStatusService) {}

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        if (this.practiceStatus.isReadOnly()) {
            this.router.navigate(["/home"]);
            return false;
        }
        return true;
    }
}
